module.exports = __webpack_public_path__ + "img/floor_f12_02.96c2a800.png";